import { useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup'

export const initialValues = {
  name: '',
  email: '',
  new_password: '',
  new_password_confirm: '',
}

const useFormPasswordChange = () => {
  const { t } = useTranslation()
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        new_password: Yup.string()
          .max(
            50,
            t('ERROR.E000002', {
              field: t('admins.password'),
              character: 50,
            })
          )
          .min(
            5,
            t('ERROR.E000002', {
              field: t('admins.password'),
              character: 5,
            })
          )
          .required(
            t('ERROR.E000001', {
              field: t('admins.password'),
            })
          ),
        new_password_confirm: Yup.string().oneOf(
          [Yup.ref('new_password'), null],
          t('admins.password_not_match')
        ),
      }),
    []
  )

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
    mode: 'onBlur',
  })

  return { Controller, methods, initialValues }
}

export default useFormPasswordChange
